import React, { useState, useEffect } from 'react';
// import styles from './AdvancedBasicCategories.module.scss';
import styles from '../../BasicCleanupsFilter/BasicCleanupsFilter.module.scss';
import AdvancedBasicBrownfield from './AdvancedBasicBrownfield/AdvancedBasicBrownfield';
import AdvancedBasicRCRA from './AdvancedBasicRCRA/AdvancedBasicRCRA'
import AdvancedBasicSuperfundNPL from './AdvancedBasicSuperfundNPL/AdvancedBasicSuperfundNPL';
import AdvancedBasicSuperfundNonNPL from './AdvancedBasicSuperfundNonNPL/AdvancedBasicSuperfundNonNPL';

const AdvancedBasicCategories = (props) => {
  const [brownfieldParams, setBrownfieldParams] = useState<Array<string>>([]);
  const [rcraParams, setRCRAParams] = useState<Array<string>>([]);
  const [superfundNPLParams, setSuperfundNPLParams] = useState<Array<string>>([]);
  const [superfundNonNPLParams, setSuperfundNonNPLParams] = useState<Array<string>>([]);

  const updateBrownfieldParams = (paramArray) => {
    setBrownfieldParams(paramArray);
  }

  const updateRCRAParams = (paramArray) => {
    setRCRAParams(paramArray);
  }

  const updateSuperfundNPLParams = (paramArray) => {
    setSuperfundNPLParams(paramArray);
  }

  const updateSuperfundNonNPLParams = (paramArray) => {
    setSuperfundNonNPLParams(paramArray);
  }

  // updates the basicParameters and passes it to AdvancedCleanupsFilter
  const updateAllBasicParams = () => {
    const paramArray: Array<string> = [
      ...brownfieldParams,
      ...rcraParams,
      ...superfundNPLParams,
      ...superfundNonNPLParams
    ];
    props.updateBasicParams(paramArray)
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { updateAllBasicParams(); }, [brownfieldParams, rcraParams, superfundNPLParams, superfundNonNPLParams]);

  useEffect(() => { }, [props.signalClear]);

  return (
    <>
      <div className={styles.SectionContainers}>
        <div className={styles.QuarterSections}>
          <AdvancedBasicBrownfield sitesLayer={props.sitesLayer} signalClear={props.signalClear}
            matchesAny={props.matchesAny} updateBrownfieldParams={updateBrownfieldParams} />
        </div>
        <div className={styles.QuarterSections}>
          <AdvancedBasicRCRA sitesLayer={props.sitesLayer} signalClear={props.signalClear}
            matchesAny={props.matchesAny} updateRCRAParams={updateRCRAParams} />
        </div>
        <div className={styles.QuarterSections}>
          <AdvancedBasicSuperfundNPL sitesLayer={props.sitesLayer} signalClear={props.signalClear}
            matchesAny={props.matchesAny} updateSuperfundNPLParams={updateSuperfundNPLParams} />
        </div>
        <div className={styles.QuarterSections}>
          <AdvancedBasicSuperfundNonNPL sitesLayer={props.sitesLayer} signalClear={props.signalClear}
            matchesAny={props.matchesAny} updateSuperfundNonNPLParams={updateSuperfundNonNPLParams} />
        </div>
      </div>
    </>
  );
}
export default AdvancedBasicCategories;